/* eslint-disable import/no-anonymous-default-export */
import axios from './axios';
import { CollectionResult } from './sessionModels';

const PITCHES = `${process.env.REACT_APP_PORTAL_URL}/api/v1/pitches`;

export type PitchDetails = {
  id: number;
  name: string;
  type?: string | null;
  fieldLength: number;
  fieldWidth: number;
  latitude: number;
  longitude: number;
  timeZone?: string | null;
  metadata?: string | null;
};

export type PitchInput = {
  name: string;
  type?: string | null;
  fieldLength: number;
  fieldWidth: number;
  latitude: number;
  longitude: number;
  metadata?: string | null;
};

export default {
  async getPitches(includeGenerated: boolean = false): Promise<PitchDetails[]> {
    const params = { offset: 0, limit: 100000, ...(includeGenerated ? {} : { generated: false }) };
    const result: CollectionResult<PitchDetails> = await axios.get(PITCHES, { params });
    return result.items;
  },
  getPitch(id: number | string): Promise<PitchDetails> {
    return axios.get(`${PITCHES}/${id}`);
  },
  addPitch(input: PitchInput): Promise<PitchDetails> {
    return axios.post(PITCHES, input);
  },
  updatePitch(id: number | string, input: PitchInput): Promise<PitchDetails> {
    return axios.put(`${PITCHES}/${id}`, input);
  },
  deletePitch(id: number | string) {
    return axios.delete(`${PITCHES}/${id}`);
  },
};
